import { gql } from '@apollo/client'

export const fragments = {
  FullPerson: gql`
    fragment FullPerson on Person {
      dob
      estimatedAnnualIncomeCents
      firstName
      lastName
      middleName
    }
  `,
  FullAddress: gql`
    fragment FullAddress on Address {
      street
      city
      state
      zip
      zipExtension
    }
  `,
}
